import { ManualClockProps } from '@vyce/core/src/types';
import { BulkClockOutSkipReason } from '@vyce/core/src/api/types';

/** Person-field option that switches the wizard to clocking out everyone on chosen locations. */
export const ALL_CLOCKED_IN_ID = 'all-clocked-in';
export const ALL_CLOCKED_IN_OPTION = { id: ALL_CLOCKED_IN_ID, name: 'All clocked-in users' };

export const defaultValues: ManualClockProps = {
  action: 'in',
  timestamp: 'now',
  verifiedLocation: true,
  bulkLocationIds: [],
};

export const stepNames = {
  SHIFT_STEP: 'ShiftStep',
  UPLOAD_PICTURE_STEP: 'UploadPictureStep',
  LOCATION_STEP: 'LocationStep',
  WHEN_CLOCK_STEP: 'WhenClockStep',
  LOCATION_VERIFIED_STEP: 'LocationVerifiedStep',
  WORKER_NAME_STEP: 'WorkerNameStep',
  DOYOUWANTTOCLOCK_STEP: 'DoYouWantToClockStep',
  BULK_LOCATION_STEP: 'BulkLocationStep',
};

export const clockOutHiddenSteps = [
  stepNames.SHIFT_STEP,
  stepNames.LOCATION_STEP,
  stepNames.LOCATION_VERIFIED_STEP,
];

export const clockInText = 'has been manually clocked in. Don’t forget to clock them out when they leave.';
export const clockOutText = 'has been manually clocked out.';

export const bulkSkipReasonText: Record<BulkClockOutSkipReason, string> = {
  not_checked_in: 'Already clocked out',
  checked_in_after_timestamp: 'Clocked in after the chosen time',
  not_in_selected_locations: 'Not on the selected locations',
};
